import * as types from './constants';
import { createDefaultCustomFields } from '../components/ProviderFields/helper';
import { store } from '../../../../../../../store';

export const editServicesInitState = {
  init: false,
  success: false,
  isLoading: true,
  isLoadingProvider: false,
  isLoadingProviderRefill: false,
  isLoadingRate: false,
  error: null,
  errorProvider: null,
  errorProviderRefill: null,
  form: null,
  providerForm: null,
  providerFormRefill: null,
};

export const editServicesReducer = (state, action) => {
  switch (action.type) {
  case types.EDIT_SERVICES_INIT:
    return {
      ...state,
      init: true,
    }
  case types.EDIT_SERVICES_ERROR:
    return {
      ...state,
      init: true,
      isLoading: false,
      error: action.error,
    }
  case types.EDIT_SERVICES_SUBMIT:
    return {
      ...state,
      isLoading: true,
      error: null,
    }
  case types.EDIT_SERVICES_SUBMIT_SUCCESS:
    return {
      ...state,
      error: null,
      success: true,
    }
  case types.ADD_SERVICES_FORM_SUCCESS:
    return {
      ...state,
      init: true,
      error: null,
      isLoading: false,
      form: action.data,
    }
  case types.EDIT_SERVICES_FORM_SUCCESS:
    return {
      ...state,
      init: true,
      error: null,
      isLoading: false,
      form: action.form,
      providerForm: action.providerForm,
      providerFormRefill: action.providerFormRefill,
      errorProvider: action.errorProvider,
      errorProviderRefill: action.errorProviderRefill,
    }
  case types.EDIT_SERVICES_FORM_CHANGE_SERVICE_NAME:
    return {
      ...state,
      form: {
        ...state.form,
        service_title: action.service_title,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_OVERFLOW:
    return {
      ...state,
      form: {
        ...state.form,
        overflow: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_INCREMENT:
    return {
      ...state,
      form: {
        ...state.form,
        increment: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_SYNC_INCREMENT:
    return {
      ...state,
      form: {
        ...state.form,
        auto_increment: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_DENY_DUPLICATES:
    return {
      ...state,
      form: {
        ...state.form,
        deny_duplicates: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_AUTO_COMPLETE_IGNORE_PROVIDER:
    return {
      ...state,
      form: {
        ...state.form,
        auto_complete_ignore_provider: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_RATE:
    return {
      ...state,
      form: {
        ...state.form,
        rate: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_RATE_WITH_SYNC:
    return {
      ...state,
      form: {
        ...state.form,
        rate: state.form.auto_rate ? action.value : state.form.rate,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_MIN:
    return {
      ...state,
      form: {
        ...state.form,
        min: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_MAX:
    return {
      ...state,
      form: {
        ...state.form,
        max: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_CATEGORY_ID:
    return {
      ...state,
      form: {
        ...state.form,
        category_id: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_MODE:
    return {
      ...state,
      providerForm: null,
      errorProvider: null,
      form: {
        ...state.form,
        start_count: 0,
        provider_id: null,
        mode: action.value,
        service_type: 0,
        auto_complete: false,
        auto_complete_ignore_provider: false,
        auto_rate: false,
        auto_min: false,
        auto_max: false,
        auto_status: false,
        auto_rate_fixed: null,
        auto_rate_percent: null,
        auto_increment: null,
        provider_service_id: null,
        cancel: false,
        drip_feed: false,
        overflow: null,
        custom_fields: {},
        refill: {
          ...state.form.refill,
          refill_check: false,
          refill_count: null,
          refill_days: store.getState()?.services.config?.max_refill_days ? store.getState().services.config.max_refill_days : 30,
          refill_minimal_quantity: null,
          refill_maximum_quantity_percent: null,
          refill_provider_id: null,
          refill_provider_service_id: null,
          refill_provider_service_params: null,
          refill_type: 0,
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_SUBSCRIPTION_TYPE:
    return {
      ...state,
      form: {
        ...state.form,
        subscription_type: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_PROVIDER_ID:
    return {
      ...state,
      isLoadingProvider: true,
      errorProvider: null,
      providerForm: null,
      form: {
        ...state.form,
        auto_complete: false,
        auto_rate: false,
        auto_min: false,
        auto_max: false,
        auto_status: false,
        auto_rate_fixed: null,
        auto_rate_percent: null,
        auto_increment: null,
        provider_service_id: null,
        drip_feed: false,
        provider_id: action.value,
        custom_fields: {},
        start_count: 0,
        refill: {
          ...state.form.refill,
          refill_check: false,
          refill_count: null,
          refill_days: store.getState()?.services.config?.max_refill_days ? store.getState().services.config.max_refill_days : 30,
          refill_minimal_quantity: null,
          refill_maximum_quantity_percent: null,
          refill_provider_id: null,
          refill_provider_service_id: null,
          refill_provider_service_params: null,
          refill_type: 0,
        },
        provider_has_error: false,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_DRIP_FEED:
    return {
      ...state,
      form: {
        ...state.form,
        drip_feed: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_CANCEL:
    return {
      ...state,
      form: {
        ...state.form,
        cancel: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_SERVICE_TYPE:
    return {
      ...state,
      form: {
        ...state.form,
        service_type: action.value,
      },
    }
  case types.EDIT_SERVICES_PROVIDER_FORM_ERROR:
    return {
      ...state,
      isLoadingProvider: false,
      errorProvider: action.error,
      providerForm: null,
    }
  case types.EDIT_SERVICES_PROVIDER_FORM_SUCCESS:
    const customField = createDefaultCustomFields(action.data);
    return {
      ...state,
      isLoadingProvider: false,
      errorProvider: null,
      providerForm: action.data,
      form: {
        ...state.form,
        custom_fields: customField,
      },
    }
  case types.EDIT_SERVICES_PROVIDER_FORM_REFILL_ERROR:
    return {
      ...state,
      isLoadingProviderRefill: false,
      errorProviderRefill: action.error,
      providerFormRefill: null,
    }
  case types.EDIT_SERVICES_PROVIDER_FORM_REFILL_SUCCESS:
    const refillCustomField = createDefaultCustomFields(action.data);
    return {
      ...state,
      isLoadingProviderRefill: false,
      errorProviderRefill: null,
      providerFormRefill: action.data,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_provider_service_params: refillCustomField,
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_PROVIDER_SERVICE_ID:
    return {
      ...state,
      form: {
        ...state.form,
        provider_service_id: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_CUSTOM_FIELDS:
    return {
      ...state,
      form: {
        ...state.form,
        custom_fields: {
          ...state.form.custom_fields,
          [action.key]: action.value,
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_START_COUNT:
    return {
      ...state,
      form: {
        ...state.form,
        auto_complete: action.value === 0 ? false : state.form.auto_complete,
        start_count: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_AUTO_COMPLETE:
    return {
      ...state,
      form: {
        ...state.form,
        auto_complete: action.value,
      },
    }

  case types.EDIT_SERVICES_FORM_CHANGE_SYNC_STATUS:
    return {
      ...state,
      form: {
        ...state.form,
        auto_status: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_SYNC_RATE:
    return {
      ...state,
      form: {
        ...state.form,
        auto_rate: action.value,
        auto_rate_fixed: action.value ? state.form.auto_rate_fixed : null,
        auto_rate_percent: action.value ? state.form.auto_rate_percent : null,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_SYNC_MIN:
    return {
      ...state,
      form: {
        ...state.form,
        auto_min: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_SYNC_MAX:
    return {
      ...state,
      form: {
        ...state.form,
        auto_max: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_RATE_LOADING:
    return {
      ...state,
      isLoadingRate: action.value,
    }
  case types.EDIT_SERVICES_FORM_CHANGE_RATE_FIXED:
    return {
      ...state,
      isLoadingRate: true,
      form: {
        ...state.form,
        auto_rate_fixed: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_RATE_PERCENT:
    return {
      ...state,
      isLoadingRate: true,
      form: {
        ...state.form,
        auto_rate_percent: action.value,
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_REFILL_ON:
    return {
      ...state,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_type: action.refill_type,
          refill_check: action.refill_check,
          refill_days: action.refill_days,
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_REFILL_OFF:
    return {
      ...state,
      isLoadingProviderRefill: false,
      errorProviderRefill: null,
      providerFormRefill: null,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_type: 0,
          refill_check: false,
          refill_minimal_quantity: null,
          refill_maximum_quantity_percent: null,
          refill_count: null,
          refill_provider_id: null,
          refill_provider_service_id: null,
          refill_provider_service_params: null,
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_REFILL_TYPE:
    return {
      ...state,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_type: action.refill_type,
          refill_check: action.refill_check,
          refill_days: action.refill_days ? action.refill_days : state.form.refill.refill_days,
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_REFILL_CHECK:
    return {
      ...state,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_check: action.value,
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_REFILL_REJECTION:
    return {
      ...state,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_deny_after_rejection: Number(action.value),
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_REFILL_COUNT:
    return {
      ...state,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_count: action.value,
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_REFILL_PROVIDER_ID:
    return {
      ...state,
      isLoadingProviderRefill: true,
      errorProviderRefill: null,
      providerFormRefill: null,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_provider_id: action.value,
          refill_provider_service_id: null,
          refill_provider_service_params: null,
          refill_provider_has_error: false,
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_REFILL_PROVIDER_SERVICE_ID:
    return {
      ...state,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_provider_service_id: action.value,
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_REFILL_CUSTOM_FIELDS:
    return {
      ...state,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_provider_service_params: {
            ...state.form.refill.refill_provider_service_params,
            [action.key]: action.value,
          },
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_REFILL_MINIMUM_QUANTITY:
    return {
      ...state,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_minimal_quantity: action.value,
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_REFILL_MAXIMAL_QUANTITY:
    return {
      ...state,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_maximum_quantity_percent: action.value,
        },
      },
    }
  case types.EDIT_SERVICES_FORM_CHANGE_REFILL_DAYS:
    return {
      ...state,
      form: {
        ...state.form,
        refill: {
          ...state.form.refill,
          refill_days: action.value,
        },
      },
    }
  default:
    throw new Error();
  }
};
